import l from '../../../../lang';
import IntegrationCard from '../integration-card';
import { ReactComponent as PrestashopIcon } from '../../../../assets/icons/prestashop.svg';
import { usePaymentIntegration } from '../../../../store/payment-integration';
import { DetailsOpened } from '../../../../store/payment-integration/interfaces';
import { segmentIntegrationsMenuPrestaShop } from '../../../../utils/analytics';

export default () => {
  const { setDetailsOpened } = usePaymentIntegration();

  return (
    <IntegrationCard
      title={l('paymentIntegration.prestashop.title')}
      icon={<PrestashopIcon />}
      color="red"
      onDetails={() => {
        segmentIntegrationsMenuPrestaShop();
        setDetailsOpened(DetailsOpened.PRESTASHOP);
      }}
      detailsText={l('paymentIntegration.card.link')}
    />
  );
};
